import React, { useContext, useEffect, useState } from 'react';
import Styled from './BiblioRates.styled';

import BiblioRateStarsSelector from './BiblioRateStarsSelector';

import closeIcon from '../../../../images/biblioteca/modal-close.svg';
import BiblioAvaliacaoService from '../../../../core/http/service/biblioteca/BiblioAvaliacao.service';
import useLogged from 'hooks/useLogged';
import { useLocation } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { GTM_Page_Biblioteca } from 'components/GoogleTagManager';
import { ToasterDefault, ToastError, ToastSuccess } from 'components/Toaster';

const RATE_LASTSESSION_KEY = 'RATE_LASTSESSION_KEY';

export interface IBiblioRateModal {
    show: boolean;
    item_id: number;
    prerate: number | null;
    onHide: () => void;
    onShow: () => void;
}

const BiblioRateModal = ({ item_id, prerate, show, onShow, onHide }: IBiblioRateModal) => {
    const service = new BiblioAvaliacaoService();
    const [loading, setLoading] = useState(false);
    const [rate, setRate] = useState(prerate ?? 0);

    const { login } = useLogged();
    const { keycloak } = useKeycloak();

    const location = useLocation();

    const sendRate = async (_rate?: number) => {
        if (rate > 0 || (_rate && _rate > 0)) {
            if (keycloak.authenticated) {
                setLoading(true);

                const response = await service.enviarAvalicaoItem(item_id, rate || _rate);
                if (response.status == 200) {
                    ToastSuccess('Avaliação enviada');
                    onHide();
                } else {
                    ToastError('Erro ao enviar avaliação');
                }
                setLoading(false);
            } else {
                login(location.pathname, `rate=${rate ?? _rate}`);
            }
        }
    };

    const checkLastSession = () => {
        const value = location.pathname.split('rate=')[1];

        if (value) {
            sendRate(parseInt(value));
            setRate(parseInt(value));
        }
    };

    useEffect(() => {
        checkLastSession();
    }, []);

    return (
        <>
            <Styled.Modal.RateButton onClick={onShow} disabled={loading} />
            <Styled.Modal.Component centered show={show} onHide={onHide}>
                <Styled.Modal.CloseContainer>
                    <Styled.Modal.CloseIcon src={closeIcon} onClick={onHide} />
                </Styled.Modal.CloseContainer>
                <Styled.Modal.Content>
                    <Styled.Modal.Title>Avaliar</Styled.Modal.Title>
                    <Styled.Modal.Subtitle>Deixe sua avaliação sobre este conteúdo</Styled.Modal.Subtitle>
                    <BiblioRateStarsSelector onSelect={(value: number) => setRate(value)} prerate={rate} />
                    <Styled.Modal.Button
                        onClick={() => {
                            GTM_Page_Biblioteca(`${item_id}`, `rate_item_${item_id}_value_${rate}`, 'send_rate_btn');
                            sendRate();
                        }}
                        disabled={rate == 0 || loading}
                    >
                        {loading ? 'Enviando...' : 'Enviar'}
                    </Styled.Modal.Button>
                </Styled.Modal.Content>
            </Styled.Modal.Component>
        </>
    );
};

export default BiblioRateModal;
